import { Collection, Feature, Map } from "ol";
import { Snap } from "ol/interaction";
import { useEffect, useState } from "react";

export function useSnap(map: Map | null, features: Collection<Feature>) {
	const [snap] = useState(new Snap({ features }));

	useEffect(() => {
		if (!map) return;

		map.addInteraction(snap);

		return () => {
			map.removeInteraction(snap);
		};
	}, [map]);

	return snap;
}